import { MixingBoardContextType } from "../../context/EditorContext/MixingBoardProvider";
import { InternalFX } from "../../store";
import { piecewiseInterp } from "../../util/interpolation";
import { bpm_to_mspb } from "../../util/quantization";
import { InternalFXNode } from "./InternalFXNode";

/*
 * Encapsulates a Tuna Effect and allows for parameter and tempo manipulation.
 */
export class TunaEffectNode extends InternalFXNode {
  private tunaNode: AudioNode;
  private preGain: GainNode;

  /*
   * Parameters:
   *  mixingBoard: MixingBoardContext (has access to AudioMaster)
   *  fxConfig: json serialization of effect params
   */
  constructor(mixingBoard: MixingBoardContextType, fxConfig: InternalFX) {
    super(mixingBoard, fxConfig);

    const effectName = fxConfig.effectId.split(".")[1];
    this.preGain = mixingBoard.audioMaster.context.createGain();
    this.tunaNode = new mixingBoard.audioMaster.tuna[effectName](
      fxConfig.params
    );
    // patch to GainNode first for tuna shim
    this._inputConnect(this.preGain)
      .connect(this.tunaNode)
      .connect(this.outputNode);
  }

  /*
   * Updates the bpm to be used for bpm-locked fx
   *
   *  Parameters:
   *    bpm: the new bpm to set (called when redux updates it)
   */
  public setBPM(bpm: number) {
    for (let param in this.fxConfig.tempoLock ?? {}) {
      const msDelay = bpm_to_mspb(bpm) * this.fxConfig.tempoLock[param];
      this.tunaNode[param] = msDelay;
    }
  }

  /*
   * When knob controlling insert effect updates, set the value
   *
   * Parameters:
   *  val: [0,1] knob value
   */
  public setValue(val: number) {
    // loop through mappings and apply to each internal param
    for (let param in this.fxConfig.mapping ?? {}) {
      const pMapping = this.fxConfig.mapping[param];
      // figure out where val is in step range
      const interpVal = piecewiseInterp(
        pMapping.stopsX,
        pMapping.stopsY,
        pMapping.stopsInterp,
        val
      );

      this.tunaNode[param] = interpVal;
    }
  }
}
